import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useNavbarStyles from './useNavbarStyles';
import { BorderAllFilled, BorderAllRegular, ClipboardTextLtrFilled, ClipboardTextLtrRegular, FolderFilled, FolderRegular, MapFilled, MapRegular, SettingsFilled, SettingsRegular, VideoFilled, VideoRegular } from '@fluentui/react-icons';
import { useLocation, useNavigate } from 'react-router-dom';
const NavigationTabs = [
    {
        name: 'Dashboard',
        Icon: BorderAllRegular,
        activeIcon: BorderAllFilled,
        path: '/dashboard'
    },
    {
        name: 'Map View',
        Icon: MapRegular,
        activeIcon: MapFilled,
        path: '/map-view'
    },
    {
        name: 'Incidents',
        Icon: ClipboardTextLtrRegular,
        activeIcon: ClipboardTextLtrFilled,
        path: '/incidents'
    },
    {
        name: 'Assets',
        Icon: FolderRegular,
        activeIcon: FolderFilled,
        path: '/detail-asset'
    },
    {
        name: 'Systems',
        Icon: VideoRegular,
        activeIcon: VideoFilled,
        path: '/live-systems'
    },
    {
        name: 'Settings',
        Icon: SettingsRegular,
        activeIcon: SettingsFilled,
        path: '/settings'
    }
];
const NavItem = ({ tab, isActive, onClick, navItemStyles, isDisabled = false }) => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    const Icon = isActive ? tab.activeIcon || tab.Icon : tab.Icon;
    return (_jsxs(ButtonBase, { sx: navItemStyles(isActive), onClick: onClick, disabled: isDisabled, children: [_jsx(Icon, { fontSize: 24, color: isActive
                    ? isLightMode
                        ? theme.palette.common.white
                        : theme.palette.grey[900]
                    : theme.palette.action.active }), _jsx(Typography, { variant: 'subtitle2', color: isActive
                    ? isLightMode
                        ? theme.palette.common.white
                        : theme.palette.grey[900]
                    : theme.palette.text.secondary, children: tab.name })] }));
};
const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { navbarContainerStyles, navItemStyles } = useNavbarStyles();
    const [selectedTab, setSelectedTab] = useState(NavigationTabs[0].name);
    // Sync state with URL on mount & page refresh
    useEffect(() => {
        const currentPath = location.pathname;
        const matchingTab = NavigationTabs.find((tab) => currentPath.startsWith(tab.path));
        if (matchingTab) {
            setSelectedTab(matchingTab.name);
        }
        else {
            // Default to the first tab if no match is found
            setSelectedTab(NavigationTabs[0].name);
            navigate(NavigationTabs[0].path, { replace: true });
        }
    }, [location.pathname, navigate]);
    const handleTabClick = (tabName, pathName) => {
        if (tabName !== selectedTab) {
            setSelectedTab(tabName);
            navigate(pathName);
        }
    };
    return (_jsx(Box, { id: 'navbar-container', sx: navbarContainerStyles, children: _jsx("nav", { className: 'navbar', children: NavigationTabs.map((tab) => (_jsx(NavItem, { tab: tab, isActive: selectedTab === tab.name, onClick: () => handleTabClick(tab.name, tab.path), navItemStyles: navItemStyles }, tab.name))) }) }));
};
export default Navbar;
